import { archivalSearchApi } from "../../../api/apiClient";

function searchSwiftMessages(data) {
  return archivalSearchApi.post(`/archival/simple-search`, data);
}

function getCountries() {
  return archivalSearchApi.get(`/shared/countries`);
}

function getCurrencies() {
  return archivalSearchApi.get(`/shared/currencies`);
}

function getMessagesTypes() {
  return archivalSearchApi.get(`/shared/message-types`);
}

function getFieldNames(id) {
  return archivalSearchApi.get(`/shared/message-types/${id}`);
}

function sendMail(data, referenceNumber) {
  return archivalSearchApi.post(`/archival/${referenceNumber}/email`, data);
}


export const swiftMessagesServices = {
  searchSwiftMessages,
  getCountries,
  getCurrencies,
  getMessagesTypes,
  getFieldNames,
  sendMail
};
